import script from "./CartIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CartIcon.vue?vue&type=script&setup=true&lang=js"

import "./CartIcon.vue?vue&type=style&index=0&id=6bbaf057&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bbaf057"]])

export default __exports__